import Image from 'next/image'
import SubmitForm from './SubmitForm';
import { FaExclamationTriangle } from 'react-icons/fa';

function HeroContent({city}: {city?: string}) {
  return (
    <div className="max-w-4xl animate-fadeIn bg-primary/80 rounded-xl p-8 md:p-12 shadow-xl backdrop-blur-sm mx-auto mt-6 mb-6 md:mt-0 md:mb-0">
      <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 text-primary-light drop-shadow-lg">
        Autoverwertung {city && `${city}`}
      </h1>
      <p className="text-base sm:text-lg md:text-xl mt-4 max-w-3xl leading-relaxed text-white/90">
        Sie möchten Ihr Auto in Viersen schnell und unkompliziert verwerten? Autoverwertung Viersen — Ob Unfallauto, Schrottauto oder altes Fahrzeug: Wir bieten Ihnen sofort einen fairen Preis, holen Ihr Fahrzeug kostenlos ab und sorgen für eine schnelle, stressfreie Abwicklung insklusive kostenlose Online-Bewertung.
      </p>
      {/* <div className="inline-flex items-center gap-2 bg-white/10 text-red-100 px-4 py-3 rounded-full mb-6 border border-red-200/40 shadow-sm shadow-red-900/20">
        <FaExclamationTriangle className="h-4 w-4 text-red-300" />
        <span className="text-sm sm:text-base font-semibold uppercase tracking-[0.12em]">KEINE ERSATZTEILE</span>
      </div> */}
      <div className="flex items-start gap-4 mb-3 mt-4 justify-center">
        <span className="text-[#FAB95B] text-3xl">★★★★★</span>
      </div>
      <div className="mt-8 flex gap-4 flex-col sm:flex-row">
        <button
          className="bg-primary-light hover:bg-primary text-white px-7 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg focus:outline-none text-lg shadow-md"
          onClick={() => {
            const form = document.getElementById('contact-form');
            if (form) {
              form.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }}
          onMouseEnter={e => e.currentTarget.classList.add('animate-bounce')}
          onMouseLeave={e => e.currentTarget.classList.remove('animate-bounce')}
        >
          Kontaktformular
        </button>
        {/* <a
          href={`tel:${process.env.NEXT_PUBLIC_PHONE_NUMBER || ''}`}
          className="flex items-center gap-3 border-2 border-primary-light hover:bg-primary-light    hover:text-primary-dark text-white px-7 py-3 rounded-lg font-bold text-xl shadow-md transition-all duration-300 inline-block hover:scale-105 focus:outline-none animate-pulse"
          style={{ letterSpacing: '0.05em' }}
          onMouseEnter={e => e.currentTarget.classList.add('animate-bounce')}
          onMouseLeave={e => e.currentTarget.classList.remove('animate-bounce')}
          aria-label={`Jetzt anrufen: ${process.env.NEXT_PUBLIC_PHONE_NUMBER}`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15l2.25-2.25a1.5 1.5 0 0 0 0-2.121l-3.75-3.75a1.5 1.5 0 0 0-2.121 0l-1.125 1.125a11.25 11.25 0 0 1-5.25-5.25l1.125-1.125a1.5 1.5 0 0 0 0-2.121l-3.75-3.75a1.5 1.5 0 0 0-2.121 0L2.25 6.75z" />
          </svg>
          <span className="tracking-wider">
            <span className="text-green-400 font-bold">Jetzt anrufen:</span> <span className="ml-1 text-yellow-400 drop-shadow-lg">{process.env.NEXT_PUBLIC_PHONE_NUMBER}</span>
          </span>
        </a> */}
      </div>
    </div>
  );
}

export default function Hero({city='',slug=''}:any) {
  // Breadcrumbs: always Home, optionally city
  // const breadcrumbs = [
  //   { name: 'Startseite', href: '/' },
  //   ...(city ? [{ name: city, href: `/${slug.toLowerCase()}` }] : [])
  // ];
  // // BreadcrumbList schema
  // const origin =
  //   typeof window !== 'undefined'
  //     ? window.location.origin
  //     : process.env.NEXT_PUBLIC_SITE_URL || 'https://www.viersen-autoverwertung24.de';

  // const breadcrumbItems = breadcrumbs.map((crumb, idx) => ({
  //   '@type': 'ListItem',
  //   position: idx + 1,
  //   name: crumb.name,
  //   item: origin + crumb.href
  // }));

  return (
    <section className="relative min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden bg-primary-dark">
      {/* BreadcrumbList Schema.org LD+JSON */}
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: breadcrumbItems
          })
        }}
      /> */}
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full z-10">
        <Image
          src="/images/cars/hero.webp"
          alt="Autoverwertung Viersen - Kostenlose Abholung von Schrottautos"
          fill
          priority
          quality={90}
          sizes="100vw"
          className="object-cover opacity-80"
          fetchPriority="high"
        />

        {/* Gradient Overlay using config colors */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-dark/90 via-primary/80 to-primary-light/60" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Content Container */}
        <HeroContent city={city} />

      </div>
    </section>
  )
}
